import React from 'react';
import ValesFilters from '../ValesFilters';

const Filters = ({
  toggleFiltersOpen,
  filtersOpen,
  filtrosVisiblesProductos,
  filtrosVisiblesOtros,
}) => {
  return (
    <>
      {filtersOpen ? (
        <section className="o-section--large">
          <div className="container">
            <ValesFilters
              onFiltersChange={() => ''}
              onFiltersClose={toggleFiltersOpen}
              filtrosVisiblesProductos={filtrosVisiblesProductos}
              filtrosVisiblesOtros={filtrosVisiblesOtros}
            />
          </div>
        </section>
      ) : null}
    </>
  );
};

export default Filters;
